module.exports = __webpack_public_path__ + "static/media/logo-white.21663502.png";